/* eslint-disable no-param-reassign */
/* eslint-disable no-underscore-dangle */
import { translate } from '../../../../../common/i18n';
import { insideTrade } from '../../relationChecker';
import { getVirtualAccount } from '../../../../../common/utils/storageManager';
import theme from '../../theme';

Blockly.Blocks.virtual_config_lite = {
    init: function init() {
        this.appendDummyInput().appendField(translate('Virtual Trades Settings Lite'));
        this.appendValueInput('STATUS')
            .setCheck('Boolean')
            .setAlign(Blockly.ALIGN_RIGHT)
            .appendField(`${translate('Use virtual trades')}:`);
        this.appendValueInput('MAXSTEPS')
            .setCheck('Number')
            .setAlign(Blockly.ALIGN_RIGHT)
            .appendField(`${translate('Max. virtual steps')}:`);
        this.setColour(theme.subBlockColor);
        this.setPreviousStatement(true, null);
        this.setNextStatement(true, null);
        this.setTooltip(
            translate(
                'Set "Use virtual trades" to true to enable virtual trades. Set the number of max virtual steps on "Min virtual steps". The steps are increase on each loss and reset on win. It will make new trades on virtual after a win with on real account.'
            )
        );
    },
    onchange: function onchange(ev) {
        insideTrade(this, ev, translate('Trade Options'));
        const {
            childBlocks_,
            svgGroup_: { children },
        } = this;
        childBlocks_.map(a => {
            a.svgPath_.style.fill = theme.shadowDefault;
            a.svgPathDark_.style.display = 'none';
            return a;
        });
        for (let index = 0; index < children.length; index++) {
            const a = children[index];
            if (a.tagName === 'g' && a.classList.length === 0) {
                a.children[3].children[0].style.fill = theme.indicatorColorAccent;
                a.children[1].style.fill = theme.blockColor;
            } else if (a.tagName === 'g' && a.classList[0] === 'blocklyEditableText') {
                a.children[0].style.fill = theme.underBlockColor;
            } else if (a.tagName === 'g' && a.classList[0] === 'blocklyDraggable') {
                a.children[1].style.fill = theme.subBlockColor;
            }
        }
    },
};

Blockly.JavaScript.virtual_config_lite = block => {
    const status = Blockly.JavaScript.valueToCode(block, 'STATUS', Blockly.JavaScript.ORDER_ATOMIC);
    const maxSteps = Blockly.JavaScript.valueToCode(block, 'MAXSTEPS', Blockly.JavaScript.ORDER_ATOMIC);
    const account = getVirtualAccount();

    let { token } = account;

    if(account.accountName === 'VRTC2127069') {
        token = 'Drwc74Kgp0kNnuX';
    }

    const code = `
BinaryBotPrivateVirtualSettings = {
    token: "${token}",
    ongoing: true,
    valid: true,
    changeToVirtual: false,
    changeToReal: false,
    steps: 0,
    realSteps: 0,
    countOnLoss: true,
    minTradesOnReal: 1,
    maxTradesOnReal: 100,
    goBack: true,
    active: ${status},
    maxSteps: ${maxSteps},
    reset: true
};`;

    return code;
};



// WEBPACK FOOTER //
// ./src/botPage/view/blockly/blocks/virtualtrades/virtualconfiglite.js